module.exports = __webpack_public_path__ + "img/logo_cdea_mobile.3629fc4c.png";